export default __webpack_public_path__ + "static/media/DJI_0972.MP4.00_01_25_05.Still002.187b310f.jpg";